export const legalVariables = {
  // CGV KDMARCHE
  VERSION: "3.0",
  DATE_EFFET: "10 septembre 2026",
  REF_CGV_KDM: "CGV-KDM-2026-003",
  KDM_LEGAL_NAME: "Félixia Vanessa PIPEROL — nom commercial PRIMACOP INTERNATIONAL BUSINESS — enseigne KDMARCHÉ",
  KDM_FORM: "Entrepreneur individuel (EI)",
  KDM_CAPITAL: "Sans objet — entrepreneur individuel",
  KDM_SIRET: "433 230 703 00020",
  KDM_RCS: "RCS Pointe-à-Pitre — SIREN 433 230 703",
  KDM_ADDRESS: "Morne Bourg, Chemin Symphart Lampecinado, 97170 Petit-Bourg, Guadeloupe",
  KDM_EMAIL: "contact@primacop.com",
  KDM_PHONE: "+590 690 90 64 29",
  KDM_TVA: "FR82433230703",
  KDM_REP_NAME: "Félixia Vanessa PIPEROL",
  KDM_REP_TITLE: "Entrepreneure individuelle",
  MOYENS_PAIEMENT: "Virement bancaire, Carte bancaire, Prélèvement SEPA B2B",
  REGLES_POINTS_EXW: "Plateforme logistique de la zone sélectionnée (adresse communiquée lors de la validation de commande)",
  DELAI_RECLAMATION_JOURS: "5",
  DUREE_AVOIR_JOURS: "90",
  FRAIS_RETOUR_CHARGE: "l'Acheteur",
  DROIT_APPLICABLE: "Droit français",
  JURIDICTION_COMPETENTE: "Tribunaux de Pointe-à-Pitre",
  JURIDICTION: "Tribunaux de Pointe-à-Pitre",
  
  // CG O'SCOP
  REF_CG_OSCOP: "CG-OSCOP-2026-003",
  OSCOP_LEGAL_NAME: "SCIC SAS OBJECTIF SCOP OUTREMER (O'SCOP)",
  OSCOP_FORM: "Société Coopérative d'Intérêt Collectif (SCIC SAS à capital variable)",
  OSCOP_CAPITAL: "Capital social : 1 500 € — capital variable minimum : 1 500 €",
  OSCOP_SIREN: "903 459 139",
  OSCOP_SIRET: "903 459 139 00015",
  OSCOP_RCS: "RCS Pointe-à-Pitre (n° 903 459 139)",
  OSCOP_ADDRESS: "13 rue Rodrigue Youyoute, 97139 Les Abymes, Guadeloupe",
  OSCOP_SIEGE_ADDRESS: "13 rue Rodrigue Youyoute, 97139 Les Abymes, Guadeloupe",
  OSCOP_EMAIL: "contact@objectifscopoutremer.com",
  OSCOP_PHONE: "05 90 46 05 21",
  OSCOP_TVA: "FR34903459139",
  OSCOP_REP_NAME: "Félixia PIPEROL",
  OSCOP_REP_TITLE: "Présidente de la SCIC — Directrice de la publication",
  PLAN_ESS_ACCES: "ESS Accès Pro – 49€ HT/mois",
  PLAN_ESS_VOLUME: "ESS Volume – 149€ HT/mois",
  PLAN_ESS_IMPACT: "ESS Impact – 299€ HT/mois",
  POLITIQUE_IMPAYE: "PAST_DUE après 3 jours, GRACE_PERIOD de 7 jours, SUSPENDED après 10 jours",
  CANAL_SUPPORT: "Email, Téléphone, Espace client",
  HORAIRES_SUPPORT: "Lun-Ven 8h-18h (heure locale)",
  PLAFOND_RESPONSABILITE_OSCOP: "le montant total des abonnements payés sur les 12 derniers mois",
  URL_PRIVACY: "/legal/politique-confidentialite",
  
  // Convention de partenariat
  REF_CONVENTION: "CONV-KDM-OSCOP-2026-001",
  DATE_DOCUMENT: "17 janvier 2026",
  DATE_SIGNATURE: "17 janvier 2026",
  LIEU_SIGNATURE: "Baie-Mahault",
  DUREE_MOIS: "36",
  PREAVIS_JOURS: "90",
  
  // Charte ESS de mutualisation
  REF_CHARTE_ESS_MUT: "CHARTE-ESS-MUT-2026-001",
  
  // Contrat de Transport LOGI'SCOP
  REF_CONTRAT_TRANSPORT: "CTR-LSC-2026-001",
  LOGISCOP_LEGAL_NAME: "LOGI'SCOP",
  LOGISCOP_FORM: "Établissement secondaire de la SCIC O'SCOP",
  LOGISCOP_ADDRESS: "13 rue Rodrigue Youyoute, 97139 Les Abymes, Guadeloupe",
  LOGISCOP_SIRET: "903 459 139 00015",
  LOGISCOP_TVA: "FR34903459139",
  LOGISCOP_EMAIL: "logistique@oscop.fr",
  LOGISCOP_PHONE: "05 90 46 05 21",

  // Hébergeur du site (mention LCEN)
  HOST_NAME: "IONOS SARL",
  HOST_ADDRESS: "7, place de la Gare, BP 70109, 57201 Sarreguemines Cedex",
  HOST_SIRET: "431 303 775 000 16",
  HOST_RCS: "RCS Sarreguemines",
  HOST_PHONE: "0970 808 911",
  
  // Facture
  LOGO_SRC: "/kdmarche-logo.svg",
  FACTURE_NUM: "FAC-XXXX-XXXX",
  DATE_FACTURE: "[Date facture]",
  DATE_ECHEANCE: "[Date échéance]",
  DEVISE: "EUR",
  ZONE_CODE: "[Code zone]",
  CLIENT_LEGAL_NAME: "[Raison sociale client]",
  CLIENT_ADDRESS: "[Adresse client]",
  CLIENT_SIRET: "[SIRET client]",
  CLIENT_TVA: "[N° TVA client]",
  CLIENT_CONTACT: "[Contact client]",
  COMMANDE_REF: "[Réf commande]",
  POINT_EXW_ADRESSE: "[Adresse point EXW]",
  CRENEAU_EXW: "[Créneau enlèvement]",
  PICKUP_REF: "[Réf enlèvement]",
  IBAN: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
  BIC: "XXXXFRPP",
  TVA_TAUX: "20",
};

// CGV KDMARCHE B2B Content (Version consolidée avec clause rémunération)
